export default __webpack_public_path__ + "static/media/category4.d88f0126.png";